import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/**
 * Lightweight hook that returns the user's active billing plan id.
 * Plans considered "paid / live-eligible":
 *   - career_pro
 *   - interview_ready_pass
 *   - team, enterprise (future)
 *
 * Returns { planId, isFree, loading, refresh }.
 */
export default function useBillingPlan() {
  const [planId, setPlanId] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/billing/status");
      setPlanId(data?.subscription?.plan_id || "free");
    } catch {
      setPlanId("free");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const isFree = planId === "free" || planId == null;
  return { planId, isFree, loading, refresh: load };
}
